import { render, staticRenderFns } from "./CardRegistration.vue?vue&type=template&id=4b355948"
import script from "./CardRegistration.vue?vue&type=script&lang=js"
export * from "./CardRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports